import type {KpPdfViewerControlPanelComponentController} from './kp-pdf-viewer-control-panel.component';
import {PdfViewerDefaultProxy} from './pdf-viewer-default-proxy';
import type PdfProxiedCommands from './pdf-proxied-commands';

export default class PdfViewerControlPanelProxy extends PdfViewerDefaultProxy<KpPdfViewerControlPanelComponentController> implements PdfProxiedCommands {

    public setPageCount(pageCount: number) {
        this.call((controller) => controller.setPageCount(pageCount));
    }

    public setCurrentPage(currentPage: number) {
        this.call((controller) => controller.setCurrentPage(currentPage));
    }

    public fitAuto() {
        this.call((controller) => controller.fitAuto());
    }

    public fitWidth() {
        this.call((controller) => controller.fitWidth());
    }

    public updateScale(scale: number) {
        this.call((controller) => controller.updateScale(scale));
    }
}
